export enum YesNoUnknown {    
    Unknown = -1,
    No = 0,
    Yes = 1
}